<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="pronto"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 63 53"
		>
			<path
				d="M31.198797,0.294368235 C48.429297,0.294368235 62.397027,10.7216506 62.397027,23.5838153 C62.397027,36.44598 48.429297,46.8732624 31.198797,46.8732624 C28.310877,46.8732624 25.518087,46.5739682 22.864527,46.0258859 L22.864527,46.0258859 L16.960797,52.4819094 C15.988707,53.5444035 14.204547,52.8641329 14.204547,51.4306388 L14.204547,51.4306388 L14.204547,43.1108859 C5.656707,38.9569329 -6.30000006e-05,31.7657682 -6.30000006e-05,23.5838153 C-6.30000006e-05,10.7216506 13.968297,0.294368235 31.198797,0.294368235 Z M43.275834,17.1062176 C39.947544,17.1062176 37.205784,19.5672882 36.791874,22.7497824 L32.587884,22.7497824 C32.190984,20.5929941 30.286494,18.9568529 27.993294,18.9568529 C25.699464,18.9568529 23.795604,20.5929941 23.398074,22.7497824 L19.134234,22.7497824 C18.758754,21.3306294 17.467254,20.2787353 15.915564,20.2787353 C14.071554,20.2787353 12.576564,21.7583706 12.576564,23.5840647 C12.576564,25.4085118 14.071554,26.8881471 15.915564,26.8881471 C17.467254,26.8881471 18.759384,25.8362529 19.134234,24.4177235 L23.398074,24.4177235 C23.795604,26.5745118 25.699464,28.2106529 27.993294,28.2106529 C30.286494,28.2106529 32.190984,26.5745118 32.587884,24.4177235 L36.791874,24.4177235 C37.205784,27.6002176 39.947544,30.0612882 43.275834,30.0612882 C46.890144,30.0612882 49.820904,27.1612529 49.820904,23.5840647 C49.820904,20.0062529 46.890144,17.1062176 43.275834,17.1062176 Z"
				fill="#FFFFFF"
				class="light"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ProntoIcon',
	components: { Icon },
	props,
}
</script>
